import React from "react";
import {Height} from "@mui/icons-material";

/**
 * @param {{
 *      recap: {
 *          price: { value: number, bestPrice: number },
 *          discount: { value: number, percentage: number, line: string }
 *      },
 *      children?: React.ReactNode
 * }} props
 */
export const ProductPurchase = ({recap, children}) => {

    const PurchaseControls = React.Children.toArray(children)
        .find(child => React.isValidElement(child) && child.type === ProductPurchase.PurchaseControls)

    if (!recap) return null;

    return (
        <div
            className="py-3 py-xl-1 rounded-2 row gap-2 gap-xl-0 align-items-center justify-content-center justify-content-xl-end"
            style={{minHeight: '100px'}}
        >
            <hr className="col-12"/>

            <div className="col-12 pb-2 pb-xl-0 col-xl-5 d-flex flex-row justify-content-center gap-2 justify-content-xl-end gap-xl-0 align-items-center">
                {
                    recap.discount.value > 0 && (
                        <>
                            <div className="d-flex gap-2">
                                {
                                    recap.discount?.percentage > 0 && (
                                        <div className="d-flex flex-column align-items-center">
                                            <small className="text-muted">%&nbsp;ahorro</small>
                                            <strong className="text-primary">
                                                <strong className="fs-5">{recap.discount.percentage.toFixed(2)}%</strong>
                                            </strong>
                                        </div>
                                    )
                                }
                                {
                                    recap.discount?.value > 0 && (
                                        <div className="d-flex flex-column align-items-center">
                                            <small className="text-muted">Ahorro</small>
                                            <strong className="text-primary">
                                                <strong className="fs-5">{recap.discount.value.toFixed(2)}€</strong>
                                            </strong>
                                        </div>
                                    )
                                }
                            </div>

                            <div className="mx-3 d-xl-flex align-items-strech fw-bold">
                                <div className="vr my-2" style={{height: '60px', width: '2px'}}></div>
                            </div>
                        </>
                    )
                }
                {
                    recap.price?.bestPrice > 0 && (
                        <div className="d-flex gap-2">
                            <div className="d-flex flex-column align-items-center">
                                <small>Total</small>
                                <div className="d-flex align-items-end gap-2">
                                    <strong className="fs-2">{recap.price?.bestPrice?.toFixed(2)}€</strong>
                                    {recap.price?.bestPrice < recap.price?.value && (
                                        <strong className="text-danger text-decoration-line-through">
                                            {recap.price?.value?.toFixed(2)}€
                                        </strong>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                }
                <div className="ms-3 d-none d-xl-flex align-items-strech fw-bold">
                    <div className="vr my-2" style={{height: '60px', width: '2px'}}></div>
                </div>
            </div>

            <div className="col-12 col-xl-5 d-flex align-items-center justify-content-center h-100">
                {PurchaseControls}
            </div>
        </div>
    );
}

ProductPurchase.PurchaseControls = ({children}) => <>{children}</>;


